<template>
    <div slot="content">
        <div class="pop-content-search">
            <el-form size="mini" label-width="80px" style="margin-left: -40px;">
                <el-row style="margin-bottom: 0px;">
                    <el-col :span="5" v-if="this.$store.state.loginInfo.groupUId==29">
                        <el-form-item label="제조사">
                            <el-input v-model="makerNm" readonly></el-input>
                            <el-input v-model="maker" v-show="false"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-else>
                        <el-form-item label="제조사">
                            <el-select v-model="maker">
                                <el-option
                                    v-for="item in makerList"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="제품군">
                            <el-row>
                                <el-col :span="subModelGroupShow ? 10: 20">
                                    <el-select  v-model="modelGroup" @change="onModelGroupChange">
                                        <el-option
                                            v-for="item in modelGroupList"
                                            :key="item.value"
                                            :label="item.value"
                                            :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="subModelGroupShow ? 10: 0">
                                    <el-select  v-model="subModelGroup" v-show="subModelGroupShow">
                                        <el-option
                                        v-for="item in subModelGroupList"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="대표모델">
                            <el-input type="text" v-model="standardModelNm" @keyup.native.enter="goOpen"/>
                        </el-form-item>    
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="모델">
                            <el-row>
                                <el-col :span="16">
                                    <el-input type="text" v-model="modelNm" @keyup.native.enter="goOpen"/>
                                </el-col>
                                <el-col :span="4">
                                    <el-button type="primary" icon="el-icon-search" @click="goOpen">
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- test -->
            <!-- <div class="field has-addons">
                <div class="mr20">
                    <span class="pop-c-name">제조사</span>
                </div>
                <div class="control is-expanded">
                    <b-select v-model="maker">
                        <option
                            v-for="item in makerList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                        </option>
                    </b-select>
                </div>
                <div class="mr20">
                    <span class="pop-c-name">제품군</span>
                </div>
                <div class="control is-expanded">
                    <b-select v-model="modelGroup" @change.native="onModelGroupChange">
                        <option
                            v-for="item in modelGroupList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                        </option>
                    </b-select>
                    <b-select v-model="subModelGroup" v-show="subModelGroupShow">
                        <option
                            v-for="item in subModelGroupList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                        </option>
                    </b-select>

                </div>
                <div class="mr20">
                    <span class="pop-c-name">대표모델</span>
                </div>
                <div class="control is-expanded">
                    <input class="form-input" type="text" v-model="standardModelNm">
                </div>
                <div class="mr20">
                    <span class="pop-c-name">모델</span>
                </div>
                <div class="control is-expanded">
                    <input class="form-input" type="text" v-model="modelNm">
                </div>
                 
                <div class="btn-wrap btn-type1 clearfix">
                    <button type="button" class="btn-size btn-gray fl_left" @click="goOpen">
                        <span class="btn-icon">
                        <i class="fas fa-search"></i>
                        </span>
                        {{ this.$i18n.messages[this.$store.state.locale].search }}
                    </button>
                </div>
                
            </div> -->
        </div>

        <div class="table-area">
            <div class="table-b">
                <ag-grid-vue 
                    style="width: 100%; height: 320px;"
                    class="ag-theme-alpine"    
                    row-selection="single"
                            
                    :column-defs="columnDefs"     
                    :grid-options="gridOptions"
                    :row-data="rowData"
                    :default-col-def="defaultColDef"
                    @rowDoubleClicked="rowDoubleClick"
                    @grid-ready="onGridReady"
                    @cell-clicked="onCellClicked" />
            </div>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from 'ag-grid-vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    props: {
        tabData: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        }
    },
    components: {AgGridVue},
    data() {
        return {
            maker: '', /** 제조사 */
            makerNm: '',
            makerList: [], /** 제조사 리스트*/
            modelGroup: '', /** 제품군 */
            modelGroupList: [], /** 제품군 리스트*/
            modelGroupNmList: [], /** 제품군 명칭 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */


            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {},
            columnDefs:[
                {
                    headerName: '제조사', 
                    width:200,
                    field:'makerNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '제품군', 
                    width:170,
                    field:'modelGroupNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '대표모델', 
                    width:170,
                    field:'standardModelNm', 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '모델', 
                    width:400,
                    field:'modelNm', 
                    cellStyle:{textAlign:'center'}
                }                   
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            form: {
                custId: '0',
                siteId: '0'
            }
        }
    },
    mounted() {
        this.form = {};
        if(this.tabData && this.tabData.length > 0){
            this.form = this.tabData[0] || {};  

            if(this.$store.state.loginInfo.groupUId==29){
                this.maker = this.tabData[0].param.agMakerCd || '';
                this.makerNm = this.tabData[0].param.agMakerNm || '';
            }        
        }
        
    },
    methods: {
        onGridReady(){
            this.getCombo({flag: 'INIT'});
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        onCellClicked(event) {
            console.log('add onCellClicked  start===', event)
            this.$emit('onCellClicked', event);
        },
        async getCombo(param) {
            let vm = this;
            if(param.flag === 'INIT'){
                // 제조사
                await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 196}})
                    .then(response => {
                        vm.makerList = response.data || [];
                        vm.makerList.unshift({key:'', value:'전체'});
                    });

                // 제품군 : ModelGroup, CAT_LVL(2)
                await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 143}})
                    .then(response => {
                        this.modelGroupNmList = response.data || []
                        this.modelGroupNmList.unshift({key:'', value:'전체'})
                    });
                // 제품군 : ModelGroup, CAT_LVL(2)
                await this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 143}})
                    .then(response => {
                        this.modelGroupList = response.data || []
                        this.modelGroupList.unshift({key:'', value:'전체'})
                        console.log('response.data :', response.data )
                    });
            } else {
                if(param.parentId === ''){
                    this.subModelGroupShow =  false
                } else{
                    this.subModelGroupShow =  true

                    // 하위 제품군 : ModelGroup, CAT_LVL(2)
                    await this.$http.get(`/api/codeMng/combo`, {params: {parentId: param.parentId}})
                        .then(response => {
                            this.subModelGroupList = response.data || []
                            this.subModelGroupList.unshift({key:'', value:'전체'})
                            this.subModelGroup = ''
                        });
                }
                
            } 
        },
        onModelGroupChange(e){
            // console.log('onModelGroupChange start====', e.target)
            // 모델이 변경시 하위 제품군 조회
            console.log("onModelGroupChange ele", e)
            this.getCombo({flag: '', parentId: e})
        },
        goOpen(){
            if(this.$store.state.loginInfo.groupUId==29 && this.maker===''){
                this.$swal({
                    type: 'warning',
                    text: '대행사의 제조사가 맵핑이 안되어 있습니다. 사용자관리에서 제조사 맵핑후 사용가능합니다.'
                });

                return false;
            }

            this.$store.commit('loading')
            const vModelIdx = this.modelGroupList.findIndex(x=>x.key === this.modelGroup)
            const vModelGroupCatKey = this.modelGroupNmList[vModelIdx].key || ''

            const vform = {
                companyId: this.$store.state.loginInfo.compCd || '',
                custId:  '0',
                siteId:  '0',
                modelCd: '',
                maker: this.maker || '',
                modelGroup: (this.subModelGroup ? this.subModelGroup : vModelGroupCatKey) || '',
                standardModelNm: this.standardModelNm || '',
                modelNm: this.modelNm || '',
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
            // console.log('add goOpen start', vform)
            this.$http.post(("/api/asMng/popup/siteModelSelect/searchModelAddList"), vform
                ).then(response => {
                console.log('addmodal response.data' , response.data)
                if(response.data.callModelSelPageList){
                    this.rowData = response.data.callModelSelPageList || []
                }
                
            }).finally(() => {
                this.$store.commit('finish')
 
            });
        }
    }
}
</script>